import React, { useEffect, useState } from 'react';
import { MapContainer, GeoJSON, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// stessa normalizzazione di AnalisiMap (chiave regione UPPERCASE)
const REG_NORM = {
  "VALLE D'AOSTA/VALLÉE D'AOSTE": "VALLE D'AOSTA",
  "TRENTINO-ALTO ADIGE/SÜDTIROL": "TRENTINO-ALTO ADIGE",
  "FRIULI-VENEZIA GIULIA": "FRIULI VENEZIA GIULIA",
};
const normReg = (n) => (n ? (REG_NORM[n.toUpperCase()] || n.toUpperCase()) : '');

function FitItalia({ geo }) {
  const map = useMap();
  useEffect(() => {
    if (!geo) return;
    try {
      const b = L.geoJSON(geo).getBounds();
      if (b.isValid()) { map.fitBounds(b, { padding: [8, 8] }); map.setMaxBounds(b.pad(0.05)); }
    } catch (e) { /* ignore */ }
    setTimeout(() => map.invalidateSize(), 80);
  }, [geo, map]);
  return null;
}

export default function RegioniMap({ regioni, onSelect }) {
  const [geo, setGeo] = useState(null);
  useEffect(() => { fetch('/italy-regions.geojson').then((r) => r.json()).then(setGeo).catch(() => {}); }, []);

  const maxTot = Math.max(1, ...Object.values(regioni || {}).map((d) => d.totale || 0));
  const styleFn = (f) => {
    const d = (regioni || {})[normReg(f.properties.reg_name)];
    const t = d ? Math.min(1, (d.totale || 0) / maxTot) : 0;
    return { fillColor: d ? `rgba(37,99,235,${0.14 + 0.5 * t})` : '#e5e9f0', weight: 1, color: '#94a3b8', fillOpacity: 1 };
  };
  const onEach = (f, layer) => { layer.on('click', () => onSelect(normReg(f.properties.reg_name))); };

  if (!geo) return <div className="m-reg-loading">Caricamento mappa…</div>;
  return (
    <MapContainer center={[42, 12.5]} zoom={5}
      dragging={false} scrollWheelZoom={false} doubleClickZoom={false} touchZoom={false}
      boxZoom={false} keyboard={false} zoomControl={false} attributionControl={false}
      style={{ width: '100%', height: '100%', background: 'transparent' }}>
      <GeoJSON key={Object.keys(regioni || {}).length ? 'loaded' : 'empty'} data={geo} style={styleFn} onEachFeature={onEach} />
      <FitItalia geo={geo} />
    </MapContainer>
  );
}
